export const defaultRegisterForm = {
  first_name: '',
  last_name: '',
  email: '',
  password: '',
  password_confirm: '',
  funnel: 'cc',
  //how_did_you_hear_about_us: '',
  //business_type: '',
  'g-recaptcha-response': ''
};
